import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import UpgradeButton from '../../libs/molecules/UpgradeButton';
import { isDesktopScreen } from '../../libs/utils/screenSizes/screenSizes';
import { useMediaQuery, useTheme } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import type { WidgetOffer } from '../../../types/eligibilityWidget/EligibilityWidgetToken';
import useEligibilityWidget from '../hooks/useEligibilityWidget';

export const makeDataTestId = (dataTestId = 'eligibility-widget') => {
  return {
    offers: `${dataTestId}.offers.offers`,
    offer: `${dataTestId}.offers.offer`,
  };
};

interface EligibilityWidgetOffersProps {
  dataTestId?: string;
  offers: WidgetOffer[];
}

const EligibilityWidgetOffers: React.FC<EligibilityWidgetOffersProps> = ({ dataTestId, offers }) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(isDesktopScreen(theme));
  const allDataTestId = makeDataTestId(dataTestId);
  const { getUpgradeButtonLabel } = useEligibilityWidget().selectors;

  return (
    <Grid
      container
      direction={{ xs: 'column', md: 'row' }}
      gap={{ xs: 1.25, md: 1 }}
      marginBottom={2.5}
      data-testid={allDataTestId.offers}
    >
      {offers?.map((offer) => (
        <UpgradeButton
          key={`${offer.journey.originCode}${offer.journey.destinationCode}${offer?.upgradeType}`}
          label={getUpgradeButtonLabel(offer)}
          endIcon={<ArrowForwardIcon fontSize={'small'} />}
          dataTestId={allDataTestId.offer}
          fullWidth={!isDesktop}
          onClick={async () => handleClick(offer.submitUrl)}
        />
      ))}
    </Grid>
  );
};
export default EligibilityWidgetOffers;

const handleClick = (url: string): void => {
  window?.open(url);
};
